import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { VehicleAvailabilityCachesModel } from '@models/agendamento-pratico/vehicle-availability-caches.model';
import { VehicleAvailabilityCachesGroupedModel } from '@models/agendamento-pratico/vehicle-availability-caches-grouped.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';
@Injectable({
  providedIn: 'root',
})
export class VehicleAvailabilityCachesService  extends BaseResourceService<VehicleAvailabilityCachesModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.PRACTICAL_SCHEDULING_API}vehicleavailabilitycache`, injector);
  }

  getAllGrouped(params?: { [param: string]: any }): Observable<VehicleAvailabilityCachesGroupedModel[]> {
    const END_POINT = `${this._url}/grouped`
    return this._httpClient.get<VehicleAvailabilityCachesGroupedModel[]>(END_POINT, { params });
  }

  getAllGroupedNew(params?: { [param: string]: any }): Observable<VehicleAvailabilityCachesGroupedModel[]> {
    const END_POINT = `${this._url}`
    return this._httpClient.get<VehicleAvailabilityCachesGroupedModel[]>(END_POINT, { params });
  }
}
